var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deck",attrs:{"id":"edit-deck-form"}},[_c('header',[_vm._v("Deck Config")]),_c('DeckForm',{attrs:{"deck":_vm.deck},on:{"save":_vm.saveDeck,"close":function($event){return _vm.$emit('close')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }